
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _500B6WtH9ofONd8I1Tz_Iw1mPpuQGpoW_45ZxIQQHsVtnnjwMeta } from "/usr/src/nuxt-app/pages/500.vue?macro=true";
import { default as index854hq0DU0W6hAW0yFkUYkOY9aVXyrnK4JiXZ6HJAn_0Meta } from "/usr/src/nuxt-app/pages/index.vue?macro=true";
import { default as ayarlarzPUZ04ZnMfaXI9l11HvSQKQYpOdH9VTeQfVi8aHLV7UMeta } from "/usr/src/nuxt-app/pages/profil/ayarlar.vue?macro=true";
import { default as bildirimlerCd0Va2KA49mUvzsbH6tczokMP2pHRX74kWoE_45oHxeyEMeta } from "/usr/src/nuxt-app/pages/profil/bildirimler.vue?macro=true";
import { default as gecmis_45odemelerqRqqn5ITluJuByCIv6Pp_45v6Ild24Fcf9BU_45hoInAY80Meta } from "/usr/src/nuxt-app/pages/profil/gecmis-odemeler.vue?macro=true";
import { default as kira_45gelirlerimwKziWrLd9LBEn5C9idMnbqC7CnpW7DCdhvSj7lVlwoAMeta } from "/usr/src/nuxt-app/pages/profil/kira-gelirlerim.vue?macro=true";
import { default as indexrrQolJhTsvGa48f83OkdZEcj6uzFowe2dVWsZ3xfFaoMeta } from "/usr/src/nuxt-app/pages/profil/portfoyum/index.vue?macro=true";
import { default as favori_45ilanlarimlmlWw9bZzQ1gGgvpc80PJOb7kmZFKV_Kxa4pf9d5f90Meta } from "/usr/src/nuxt-app/pages/profil/favori-ilanlarim.vue?macro=true";
import { default as kisisel_45bilgilerim2zCgoi6IghwodNdrbj7SQyyxpoUJTozkLueWIE2UjaYMeta } from "/usr/src/nuxt-app/pages/profil/kisisel-bilgilerim.vue?macro=true";
import { default as kaydedilen_45aramalar_45v3_EWcGFdJP37Dd9_45s64nRXDBkBOOvJ6x19P3uFca0Meta } from "/usr/src/nuxt-app/pages/profil/kaydedilen-aramalar.vue?macro=true";
import { default as indexf9_NJvacENZQmKgZqYsSPaAIO_j5fnV_45l7TpcHEIKIYMeta } from "/usr/src/nuxt-app/pages/profil/portfoyum/[id]/index.vue?macro=true";
import { default as indexoywODWALsQqKj5sEwTIF23PxlUcI4UvReDUIIL8J6vQMeta } from "/usr/src/nuxt-app/pages/profil/satin-alma-sureci/index.vue?macro=true";
import { default as indexQ3BY55WiMe2SbKSZpmUPCwxBZD6MKN6gd4sgwbOctXUMeta } from "/usr/src/nuxt-app/pages/profil/satin-alma-sureci/[id]/index.vue?macro=true";
import { default as indexZYNA64NyNWIyZgCmhfELoEF1DpZCXjY_45BdeaWU_45_GecMeta } from "/usr/src/nuxt-app/pages/profil/portfoyum/[id]/urun-gorselleri/index.vue?macro=true";
import { default as index3q_45Zjs7_45LAqQNIDYhk4b9yyzIWUFANWWqxWGDLErY7IMeta } from "/usr/src/nuxt-app/pages/profil/satin-alma-sureci/[id]/urun-gorselleri/index.vue?macro=true";
import { default as profil8UWDSZ8nvmkiTj8axXjP2SBaGG2lGFvwvRVvzMA2km0Meta } from "/usr/src/nuxt-app/pages/profil.vue?macro=true";
import { default as indexX8Am87WFnGQMHW8ukwbik63_iaTf7rglqAcZtO8ZFLkMeta } from "/usr/src/nuxt-app/pages/blog/index.vue?macro=true";
import { default as indexcOPsSvDm9lLnrt5gXaCoCHwMNz8jXNwVdTY2dZtiDekMeta } from "/usr/src/nuxt-app/pages/rams/index.vue?macro=true";
import { default as indexcN85p37PfMS1j_aynzNG978uROtEVccJ3_45eOADLVlCcMeta } from "/usr/src/nuxt-app/pages/uye-ol/index.vue?macro=true";
import { default as _91categoryName_93unr5VapH8AxUL1k3PidKULonB_45TdQlFeob7BkBbGyBsMeta } from "/usr/src/nuxt-app/pages/[categoryName].vue?macro=true";
import { default as indexPFvYQjG4ElwoZpQBRrSaXY7_45AMhdozm_eI8EUUz8wkAMeta } from "/usr/src/nuxt-app/pages/iletisim/index.vue?macro=true";
import { default as indexzQhmF5Gau_45aaUPOOtj4l4LWagfMzmzkFr8vI38r2vsIMeta } from "/usr/src/nuxt-app/pages/firsatlar/index.vue?macro=true";
import { default as indexjRbNAcT_DFUZctfCns34n8wTOulsLoix004ahn0RLq0Meta } from "/usr/src/nuxt-app/pages/giris-yap/index.vue?macro=true";
import { default as indexweAn7dI6Ih_45AKB2A1CjRwk9NcHKz5z8LKEOK0a98GjcMeta } from "/usr/src/nuxt-app/pages/hakkimizda/index.vue?macro=true";
import { default as indexWMM_p3_PMf8KW_45qOB4rscZYoAB0oBx4pUGbO3Ag_OyEMeta } from "/usr/src/nuxt-app/pages/yatirimlar/index.vue?macro=true";
import { default as index6LDCASCA7xAkR39PiEGz9OSL_hy7m8OkNYVRAoOuBc4Meta } from "/usr/src/nuxt-app/pages/odeme-sonuc/index.vue?macro=true";
import { default as indexjgOy7v3O_97MZi3K37uhl3_34klQqE9BeTIVtxSwXJoMeta } from "/usr/src/nuxt-app/pages/nasil-calisir/index.vue?macro=true";
import { default as indexyVtR9iuygSgB9W7O74dHNz8gsIJhgGKNgMPCcs1rkgAMeta } from "/usr/src/nuxt-app/pages/sifremi-unuttum/index.vue?macro=true";
import { default as indexPaEczQ91_FXZPq9jYLxNa28IK2SkaeBucwuYAFkXOzcMeta } from "/usr/src/nuxt-app/pages/firsatlar/[region]/index.vue?macro=true";
import { default as indexhf6RmUzLH0AdtD_45k1F3q6qixpEo4DS8UFsZvc4sY1MUMeta } from "/usr/src/nuxt-app/pages/yatirimlar/kiralandi/index.vue?macro=true";
import { default as index5sAjGTYnUnEEaiqLq3t6PK1bMgki1R_cMTWZ9bmSYXkMeta } from "/usr/src/nuxt-app/pages/sikca-sorulan-sorular/index.vue?macro=true";
import { default as _91contractName_93B7TMpYfNDPYR06BVDA7WePmwuJPibiLMYWMagUzxUAoMeta } from "/usr/src/nuxt-app/pages/[categoryUrl]/[contractName].vue?macro=true";
import { default as indexpiTA2gdxMo9R0Gs_45GRPUf1F3BCYb2ZZwwl6Beyfxc2sMeta } from "/usr/src/nuxt-app/pages/yatirimlar/satis-bitti/index.vue?macro=true";
import { default as index_9Uv5PUarqxM7yPavjnrG5T__459pVn6TJV09kGFMtt2EMeta } from "/usr/src/nuxt-app/pages/blog/[categorySlugTitle]/index.vue?macro=true";
import { default as index0RC_mvg4tulT6TNnyhVaSa88RyQEYb9L8GEaB0OOYOcMeta } from "/usr/src/nuxt-app/pages/firsatlar/gelecek-projeler/index.vue?macro=true";
import { default as indexSzoYayNSgLA7H_8jM2Gx_45MQ_g4gAcLH2BBybKg1ylF0Meta } from "/usr/src/nuxt-app/pages/blog/[slugTitle]_[articleId]/index.vue?macro=true";
import { default as index5t9dTUCDlYfoS1AsUuKkAQN9uIrhykPSOWlDye8phdwMeta } from "/usr/src/nuxt-app/pages/firsatlar/[slugTitle]_[advertisementId]/index.vue?macro=true";
import { default as indexmJQR22DIxeHRj9_45NV_450_Vasrn_I1jgAA9ugCPFHvw4UMeta } from "/usr/src/nuxt-app/pages/yatirimlar/[slugTitle]_[advertisementId]/index.vue?macro=true";
import { default as index2b49ugVEFq1PcV5wvW1qSuC8Pf_45v_3k8LGE7z1VLpAsMeta } from "/usr/src/nuxt-app/pages/blog/[categorySlugTitle]/[slugTitle]_[articleId]/index.vue?macro=true";
import { default as index4vkX8Meq3V3dQn_HvneKdKwFEnSCGWkGGMvMFFv4lkQMeta } from "/usr/src/nuxt-app/pages/firsatlar/[region]/[slugTitle]_[advertisementId]/index.vue?macro=true";
import { default as index9msbh6PW4k1U1wlpMMs_j_V9crVA_45needjY0jn5DwYgMeta } from "/usr/src/nuxt-app/pages/yatirimlar/kiralandi/[slugTitle]_[advertisementId]/index.vue?macro=true";
import { default as indexqJEsgkHXXpsXd6_45a23gwuYxBRHpSqC8RjvIC0sxFgiwMeta } from "/usr/src/nuxt-app/pages/yatirimlar/satis-bitti/[slugTitle]_[advertisementId]/index.vue?macro=true";
import { default as indexgLulOuCYBaDtLUrkZrX981_456FMTIMs8w5DuQ3bgyDIcMeta } from "/usr/src/nuxt-app/pages/firsatlar/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue?macro=true";
import { default as indexEpEL7FhnJaauMe_45R_FwWdFMNtxViaVWdZnimvMkdI0wMeta } from "/usr/src/nuxt-app/pages/firsatlar/gelecek-projeler/[slugTitle]_[advertisementId]/index.vue?macro=true";
import { default as indexZdy_45LhWl6XsJGyWouzXmQ30qCbta6lJCioOoi5NVY0MMeta } from "/usr/src/nuxt-app/pages/yatirimlar/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue?macro=true";
import { default as indexVg1Wbya_rTHpY1zSO9tGmg7_45WmTfJPNoKhCoTxepgoAMeta } from "/usr/src/nuxt-app/pages/firsatlar/[region]/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue?macro=true";
import { default as indexU2GuZh7F2b31JdXla1GOhyRNggcbYAkwaXeHO92sCTgMeta } from "/usr/src/nuxt-app/pages/yatirimlar/kiralandi/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue?macro=true";
import { default as indexFzsqa9rSdSwF3HghkC1KuM7dKaGgS9JOMNkCMZsbqpkMeta } from "/usr/src/nuxt-app/pages/yatirimlar/satis-bitti/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue?macro=true";
import { default as index5yTgrxPvSIVe4KlqaLJeyekONwtFSaJp9GGC8akRIAwMeta } from "/usr/src/nuxt-app/pages/firsatlar/gelecek-projeler/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue?macro=true";
import { default as component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta } from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8 } from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "500",
    path: "/500",
    component: () => import("/usr/src/nuxt-app/pages/500.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/nuxt-app/pages/index.vue")
  },
  {
    name: "profil",
    path: "/profil",
    component: () => import("/usr/src/nuxt-app/pages/profil.vue"),
    children: [
  {
    name: "profil-ayarlar",
    path: "ayarlar",
    component: () => import("/usr/src/nuxt-app/pages/profil/ayarlar.vue")
  },
  {
    name: "profil-bildirimler",
    path: "bildirimler",
    component: () => import("/usr/src/nuxt-app/pages/profil/bildirimler.vue")
  },
  {
    name: "profil-gecmis-odemeler",
    path: "gecmis-odemeler",
    component: () => import("/usr/src/nuxt-app/pages/profil/gecmis-odemeler.vue")
  },
  {
    name: "profil-kira-gelirlerim",
    path: "kira-gelirlerim",
    component: () => import("/usr/src/nuxt-app/pages/profil/kira-gelirlerim.vue")
  },
  {
    name: "profil-portfoyum",
    path: "portfoyum",
    component: () => import("/usr/src/nuxt-app/pages/profil/portfoyum/index.vue")
  },
  {
    name: "profil-favori-ilanlarim",
    path: "favori-ilanlarim",
    component: () => import("/usr/src/nuxt-app/pages/profil/favori-ilanlarim.vue")
  },
  {
    name: "profil-kisisel-bilgilerim",
    path: "kisisel-bilgilerim",
    component: () => import("/usr/src/nuxt-app/pages/profil/kisisel-bilgilerim.vue")
  },
  {
    name: "profil-kaydedilen-aramalar",
    path: "kaydedilen-aramalar",
    component: () => import("/usr/src/nuxt-app/pages/profil/kaydedilen-aramalar.vue")
  },
  {
    name: "profil-portfoyum-id",
    path: "portfoyum/:id()",
    component: () => import("/usr/src/nuxt-app/pages/profil/portfoyum/[id]/index.vue")
  },
  {
    name: "profil-satin-alma-sureci",
    path: "satin-alma-sureci",
    component: () => import("/usr/src/nuxt-app/pages/profil/satin-alma-sureci/index.vue")
  },
  {
    name: "profil-satin-alma-sureci-id",
    path: "satin-alma-sureci/:id()",
    component: () => import("/usr/src/nuxt-app/pages/profil/satin-alma-sureci/[id]/index.vue")
  },
  {
    name: "profil-portfoyum-id-urun-gorselleri",
    path: "portfoyum/:id()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/profil/portfoyum/[id]/urun-gorselleri/index.vue")
  },
  {
    name: "profil-satin-alma-sureci-id-urun-gorselleri",
    path: "satin-alma-sureci/:id()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/profil/satin-alma-sureci/[id]/urun-gorselleri/index.vue")
  }
]
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/usr/src/nuxt-app/pages/blog/index.vue")
  },
  {
    name: "rams",
    path: "/rams",
    component: () => import("/usr/src/nuxt-app/pages/rams/index.vue")
  },
  {
    name: "uye-ol",
    path: "/uye-ol",
    component: () => import("/usr/src/nuxt-app/pages/uye-ol/index.vue")
  },
  {
    name: "categoryName",
    path: "/:categoryName()",
    component: () => import("/usr/src/nuxt-app/pages/[categoryName].vue")
  },
  {
    name: "iletisim",
    path: "/iletisim",
    component: () => import("/usr/src/nuxt-app/pages/iletisim/index.vue")
  },
  {
    name: "firsatlar",
    path: "/firsatlar",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/index.vue")
  },
  {
    name: "giris-yap",
    path: "/giris-yap",
    component: () => import("/usr/src/nuxt-app/pages/giris-yap/index.vue")
  },
  {
    name: "hakkimizda",
    path: "/hakkimizda",
    component: () => import("/usr/src/nuxt-app/pages/hakkimizda/index.vue")
  },
  {
    name: "yatirimlar",
    path: "/yatirimlar",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/index.vue")
  },
  {
    name: "odeme-sonuc",
    path: "/odeme-sonuc",
    component: () => import("/usr/src/nuxt-app/pages/odeme-sonuc/index.vue")
  },
  {
    name: "nasil-calisir",
    path: "/nasil-calisir",
    component: () => import("/usr/src/nuxt-app/pages/nasil-calisir/index.vue")
  },
  {
    name: "sifremi-unuttum",
    path: "/sifremi-unuttum",
    component: () => import("/usr/src/nuxt-app/pages/sifremi-unuttum/index.vue")
  },
  {
    name: "firsatlar-region",
    path: "/firsatlar/:region()",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/[region]/index.vue")
  },
  {
    name: "yatirimlar-kiralandi",
    path: "/yatirimlar/kiralandi",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/kiralandi/index.vue")
  },
  {
    name: "sikca-sorulan-sorular",
    path: "/sikca-sorulan-sorular",
    component: () => import("/usr/src/nuxt-app/pages/sikca-sorulan-sorular/index.vue")
  },
  {
    name: "categoryUrl-contractName",
    path: "/:categoryUrl()/:contractName()",
    component: () => import("/usr/src/nuxt-app/pages/[categoryUrl]/[contractName].vue")
  },
  {
    name: "yatirimlar-satis-bitti",
    path: "/yatirimlar/satis-bitti",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/satis-bitti/index.vue")
  },
  {
    name: "blog-categorySlugTitle",
    path: "/blog/:categorySlugTitle()",
    component: () => import("/usr/src/nuxt-app/pages/blog/[categorySlugTitle]/index.vue")
  },
  {
    name: "firsatlar-gelecek-projeler",
    path: "/firsatlar/gelecek-projeler",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/gelecek-projeler/index.vue")
  },
  {
    name: "blog-slugTitle_articleId",
    path: "/blog/:slugTitle()_:articleId()",
    component: () => import("/usr/src/nuxt-app/pages/blog/[slugTitle]_[articleId]/index.vue")
  },
  {
    name: "firsatlar-slugTitle_advertisementId",
    path: "/firsatlar/:slugTitle()_:advertisementId()",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/[slugTitle]_[advertisementId]/index.vue")
  },
  {
    name: "yatirimlar-slugTitle_advertisementId",
    path: "/yatirimlar/:slugTitle()_:advertisementId()",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/[slugTitle]_[advertisementId]/index.vue")
  },
  {
    name: "blog-categorySlugTitle-slugTitle_articleId",
    path: "/blog/:categorySlugTitle()/:slugTitle()_:articleId()",
    component: () => import("/usr/src/nuxt-app/pages/blog/[categorySlugTitle]/[slugTitle]_[articleId]/index.vue")
  },
  {
    name: "firsatlar-region-slugTitle_advertisementId",
    path: "/firsatlar/:region()/:slugTitle()_:advertisementId()",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/[region]/[slugTitle]_[advertisementId]/index.vue")
  },
  {
    name: "yatirimlar-kiralandi-slugTitle_advertisementId",
    path: "/yatirimlar/kiralandi/:slugTitle()_:advertisementId()",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/kiralandi/[slugTitle]_[advertisementId]/index.vue")
  },
  {
    name: "yatirimlar-satis-bitti-slugTitle_advertisementId",
    path: "/yatirimlar/satis-bitti/:slugTitle()_:advertisementId()",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/satis-bitti/[slugTitle]_[advertisementId]/index.vue")
  },
  {
    name: "firsatlar-slugTitle_advertisementId-urun-gorselleri",
    path: "/firsatlar/:slugTitle()_:advertisementId()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue")
  },
  {
    name: "firsatlar-gelecek-projeler-slugTitle_advertisementId",
    path: "/firsatlar/gelecek-projeler/:slugTitle()_:advertisementId()",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/gelecek-projeler/[slugTitle]_[advertisementId]/index.vue")
  },
  {
    name: "yatirimlar-slugTitle_advertisementId-urun-gorselleri",
    path: "/yatirimlar/:slugTitle()_:advertisementId()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue")
  },
  {
    name: "firsatlar-region-slugTitle_advertisementId-urun-gorselleri",
    path: "/firsatlar/:region()/:slugTitle()_:advertisementId()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/[region]/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue")
  },
  {
    name: "yatirimlar-kiralandi-slugTitle_advertisementId-urun-gorselleri",
    path: "/yatirimlar/kiralandi/:slugTitle()_:advertisementId()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/kiralandi/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue")
  },
  {
    name: "yatirimlar-satis-bitti-slugTitle_advertisementId-urun-gorselleri",
    path: "/yatirimlar/satis-bitti/:slugTitle()_:advertisementId()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/yatirimlar/satis-bitti/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue")
  },
  {
    name: "firsatlar-gelecek-projeler-slugTitle_advertisementId-urun-gorselleri",
    path: "/firsatlar/gelecek-projeler/:slugTitle()_:advertisementId()/urun-gorselleri",
    component: () => import("/usr/src/nuxt-app/pages/firsatlar/gelecek-projeler/[slugTitle]_[advertisementId]/urun-gorselleri/index.vue")
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/gelecek-projeler",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/firsatlar/gelecek_projeler",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/gelecek-projeler/amerika",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/gelecek-projeler/anadolu-yakasi",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/hisseler",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/hisseler/:pathMatch(.*)",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/hisseler/kiralandi",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/hisseler/satis-bitti",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/mustakil-tapu-nedir",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/taks-ve-kaks-emsal",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/tapu-randevusu-nasil-alinir",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/dxy-dolar-endeksi-nedir",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/intifa-hakki",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/tahvil-nedir",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/tapuda-serh",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/kat-mulkiyeti-ne-demek",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/dask-nedir-nasil-hesaplanir",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/likidite-nedir-likidite-orani-ve-likidite-tuzagi-ne-demektir",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gelenekselden-dijitale-divissa-ile-yeni-nesil-hisseli-konut-yatirim-rehberi/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/etkinlikler",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/category/genel",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/category/finans-ekonomi",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/anasayfa",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/anasayfa/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gayrimenkul-rehberi",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gayrimenkul-rehberi/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gayrimenkul-ve-yatirim",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gayrimenkul-ve-yatirim/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/finans-ve-ekonomi",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/finans-ve-ekonomi/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-nedir/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/yatirimlar/forev-modern-vadi_11888926",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-ve-geleneksel-konut/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/pasif-gelir-olarak-hisseli-konut/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/pasif-gelir-olarak-hisseli-konut",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-deger-artisi-hesaplama/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-deger-artisi-hesaplama",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/gelecek-projeler/istanbul/zin-d-diamond-31_13399190",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/gelecek-projeler/istanbul/ege-yapi-kordon-istanbul_10236649",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/gelecek-projeler/istanbul/zin-d-diamond-21_19004969",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-tapu-nedir-islemleri-nasil-yapilir/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konutta-kira-paylasimi-nasil-yapilir/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-satisinda-dikkat-edilmesi-gerekenler-nelerdir/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-tapu-nedir-islemleri-nasil-yapilir-divissa/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konutta-kira-paylasimi-nasil-yapilir-divissa/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konutta-deger-artisi-nasil-hesaplanir-divissa/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gelecegin-yatirim-platformu-divissadan-onemli-basin-toplantisi/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gelenekselden-dijitale-divissa-ile-hisseli-konut-yatirim-rehberi/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/gelecegin-gayrimenkul-yatirim-platformu-divissadan-onemli-basin-toplantisi/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-alacaklara-oneriler-ve-dikkat-edilmesi-gerekenler/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/divissa-ile-yatirim-kucuk-butcelerle-hisseli-konutlara-sahip-olun/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-yatirimi-ve-geleneksel-konut-yatirimi-detayli-karsilastirma/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/pasif-gelir-kaynagi-olarak-hisseli-konut-kira-gelirinin-avantaji/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/blog/hisseli-konut-nedir-nasil-alinir-ve-nelere-dikkat-edilmelidir/",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  }
]